module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 3
// module chunks = 36 37 38 39 40 41 42 43 44 45 46 47 48